import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ImageFileUpload, postData } from "../../../utility/Utility";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

export default function UpdateEmployee() {
  const navigate = useNavigate();
  const { state } = useLocation();


  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categoryImage: null,
    status: true,
    existingImage: ""
  });
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    if (state?.categoryData) {
      const { title, description, status, image } = state.categoryData;

      setFormData({
        title: title || "",
        description: description || "",
        status: status || true,
        categoryImage: null,
        existingImage: image || ""
      });

      if (image) {
        setImagePreview(image);
      }
    }
  }, [state]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "categoryImage" && files && files[0]) {
      const file = files[0];
      setFormData((prev) => ({ ...prev, [name]: file }));

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const toggleActive = () => {
    setFormData((prev) => ({ ...prev, status: !prev.status }));
  };

  const uploadImage = async () => {
    if (!formData.categoryImage) return formData.existingImage;

    const imageFormData = new FormData();
    imageFormData.append("file", formData.categoryImage);

    try {
      const response = await ImageFileUpload("/api/admin/upload?is_upload=s3", imageFormData);

      if (response?.success) {
        return response?.url || response.data?.imageUrl || response.data?.filePath;
      } else {
        toast.error(response?.message || "Image upload failed");
        return null;
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error(error.response?.data?.message || "Error uploading image");
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim() || !formData.description.trim()) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      // Upload image if a new one was selected
      let imageUrl = formData.existingImage;
      if (formData.categoryImage) {
        const uploadedImageUrl = await uploadImage();
        if (!uploadedImageUrl) {
          setLoading(false);
          return;
        }
        imageUrl = uploadedImageUrl;
      }

      // Prepare the data to send
      const payload = {
        title: formData.title,
        description: formData.description,
        status: formData.status,
        image: imageUrl,
        id: state?.categoryData?._id // Assuming your API needs the category ID
      };

      const response = await postData("api/categories/update", payload);

      if (response?.status) {
        toast.success("Category updated successfully!");
        navigate(-1);
      } else {
        throw new Error(response?.message || "Failed to update category");
      }
    } catch (error) {
      console.error("Update category error:", error);
      toast.error(error.response?.data?.message || error.message || "Error updating category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={5000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <div className="page-title-box">
                <h4 className="mb-1">Category Management</h4>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">Category</li>
                  <li className="breadcrumb-item active">Update Category</li>
                </ol>
              </div>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fas fa-arrow-left me-1"></i> Back
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">Update Category</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* Category Title */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="title" className="form-label fw-medium">
                          Insurance Type <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="title"
                          name="title"
                          className="form-control"
                          placeholder="Enter category title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                          minLength={3}
                          maxLength={100}
                        />
                      </div>
                    </div>

                    {/* Category Image */}
                    {/* <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="categoryImage" className="form-label fw-medium">
                          Category Image
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="file"
                          id="categoryImage"
                          name="categoryImage"
                          className="form-control"
                          onChange={handleInputChange}
                          accept="image/*"
                        />
                        <small className="text-muted d-block mt-1">
                          Recommended: 800x600px, Max 2MB (JPEG/PNG)
                        </small>
                        {imagePreview && (
                          <div className="mt-2">
                            <img
                              src={imagePreview}
                              alt="Preview"
                              className="img-thumbnail"
                              style={{ maxWidth: "200px", maxHeight: "150px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div> */}

                    {/* Status */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label className="form-label fw-medium">Status</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check form-switch d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="status"
                            checked={formData.status}
                            onChange={toggleActive}
                            role="switch"
                            style={{ width: "2.5em", height: "1.25em" }}
                          />
                          <label className="form-check-label ms-2" htmlFor="status">
                            {formData.status !== 'inactive' ? (
                              <span className="text-success">Active</span>
                            ) : (
                              <span className="text-muted">Inactive</span>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label htmlFor="description" className="form-label fw-medium">
                          Description <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <textarea
                          className="form-control"
                          id="description"
                          name="description"
                          rows={4}
                          placeholder="Describe the category..."
                          value={formData.description}
                          onChange={handleInputChange}
                          required
                          minLength={10}
                        />
                        <small className="text-muted">Minimum 10 characters</small>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="row mt-4">
                      <div className="col-md-6 offset-md-3">
                        <button
                          type="submit"
                          className="btn btn-primary py-2"
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Update Category"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}